import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
import { useSelector } from 'react-redux';
import { useIsAdmin } from '@/hooks/usePermission';

const SetupGuideContext = createContext(null);

export const SetupGuideProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const autoOpenedRef = useRef(false);

  const profile = useSelector((state) => state.auth?.profile);
  const isAdmin = useIsAdmin();
  const dismissed = profile?.setupGuideData?.dismissed;

  useEffect(() => {
    if (autoOpenedRef.current) return;
    if (!profile?.id) return;
    autoOpenedRef.current = true;
    if (isAdmin && !dismissed) {
      setIsOpen(true);
    }
  }, [profile?.id, isAdmin, dismissed]);

  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <SetupGuideContext.Provider value={{ isOpen, open, close, toggle }}>
      {children}
    </SetupGuideContext.Provider>
  );
};

export const useSetupGuide = () => {
  const ctx = useContext(SetupGuideContext);
  if (!ctx)
    throw new Error('useSetupGuide must be used within SetupGuideProvider');
  return ctx;
};
